require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interviste-rosanna-carloni.json") })
        }
      }, "path---interviste-rosanna-carloni");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interviste-rosanna-carloni!./.cache/json/interviste-rosanna-carloni.json
// module id = 688
// module chunks = 231608221292675